// extracted by mini-css-extract-plugin
export default {"header":"header__3Cnfx","headerTitle":"headerTitle__2nlHs"};
    if(module.hot) {
      // 1778491673428
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  